/* eslint-disable jsx-a11y/label-has-associated-control */
import { Col, Row, Container } from "react-bootstrap";
import {
    StyledHourInput,
    StyledHourContainer,
    StyledInfoLabel,
} from "../../../styles/pages/CheckinParameters/CheckinParametersStyles";

interface ICheckinProps {
    horarioIniManha: string;
    horarioFimManha: string;
    horarioIniTarde: string;
    horarioFimTarde: string;
    horarioIniNoite: string;
    horarioFimNoite: string;
    setHorarioIniManha: (value: string) => void;
    setHorarioFimManha: (value: string) => void;
    setHorarioIniTarde: (value: string) => void;
    setHorarioFimTarde: (value: string) => void;
    setHorarioIniNoite: (value: string) => void;
    setHorarioFimNoite: (value: string) => void;
}

const CheckinRange: React.FC<ICheckinProps> = ({
    horarioIniManha,
    horarioFimManha,
    horarioIniTarde,
    horarioFimTarde,
    horarioIniNoite,
    horarioFimNoite,
    setHorarioIniManha,
    setHorarioFimManha,
    setHorarioIniTarde,
    setHorarioFimTarde,
    setHorarioIniNoite,
    setHorarioFimNoite,
    // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
    return (
        <>
            <Container fluid style={StyledHourContainer}>
                <Row>
                    <Col>
                        <StyledInfoLabel>Manhã</StyledInfoLabel>
                    </Col>
                </Row>
                <Row xs="auto">
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="time"
                                className="form-control"
                                id="HorarioInicialM"
                                placeholder="00:00"
                                style={{
                                    color:
                                        horarioIniManha !== ""
                                            ? "black"
                                            : "red",
                                    borderColor:
                                        horarioIniManha !== ""
                                            ? "#787878"
                                            : "red",
                                }}
                                value={horarioIniManha}
                                onChange={(e) =>
                                    setHorarioIniManha(e.target.value)
                                }
                                required
                            />
                            <label
                                style={{
                                    color:
                                        horarioIniManha !== ""
                                            ? "black"
                                            : "red",
                                }}
                                htmlFor="HorarioInicialM"
                            >
                                Horário inicial
                            </label>
                        </div>
                    </Col>
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="time"
                                className="form-control"
                                id="HorarioFinalM"
                                placeholder="00:00"
                                style={{
                                    color:
                                        horarioFimManha !== ""
                                            ? "black"
                                            : "red",
                                    borderColor:
                                        horarioFimManha !== ""
                                            ? "#787878"
                                            : "red",
                                }}
                                value={horarioFimManha}
                                onChange={(e) =>
                                    setHorarioFimManha(e.target.value)
                                }
                                required
                            />
                            <label
                                htmlFor="HorarioFinalM"
                                style={{
                                    color:
                                        horarioFimManha !== ""
                                            ? "black"
                                            : "red",
                                }}
                            >
                                Horário final
                            </label>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Container fluid style={StyledHourContainer}>
                <Row>
                    <Col>
                        <StyledInfoLabel>Tarde</StyledInfoLabel>
                    </Col>
                </Row>
                <Row xs="auto">
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="time"
                                className="form-control"
                                id="HorarioInicialT"
                                style={{
                                    color:
                                        horarioIniTarde !== ""
                                            ? "black"
                                            : "red",
                                    borderColor:
                                        horarioIniTarde !== ""
                                            ? "#787878"
                                            : "red",
                                }}
                                placeholder="00:00"
                                value={horarioIniTarde}
                                onChange={(e) =>
                                    setHorarioIniTarde(e.target.value)
                                }
                                required
                            />
                            <label
                                style={{
                                    color:
                                        horarioIniTarde !== ""
                                            ? "black"
                                            : "red",
                                }}
                                htmlFor="HorarioInicialT"
                            >
                                Horário inicial
                            </label>
                        </div>
                    </Col>
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="time"
                                className="form-control"
                                id="HorarioFinalT"
                                placeholder="00:00"
                                style={{
                                    color:
                                        horarioFimTarde !== ""
                                            ? "black"
                                            : "red",
                                    borderColor:
                                        horarioFimTarde !== ""
                                            ? "#787878"
                                            : "red",
                                }}
                                value={horarioFimTarde}
                                onChange={(e) =>
                                    setHorarioFimTarde(e.target.value)
                                }
                                required
                            />
                            <label
                                htmlFor="HorarioFinalT"
                                style={{
                                    color:
                                        horarioFimTarde !== ""
                                            ? "black"
                                            : "red",
                                }}
                            >
                                Horário final
                            </label>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Container fluid style={StyledHourContainer}>
                <Row>
                    <Col>
                        <StyledInfoLabel>Noite</StyledInfoLabel>
                    </Col>
                </Row>
                <Row xs="auto">
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="time"
                                className="form-control"
                                id="HorarioInicialN"
                                placeholder="00:00"
                                style={{
                                    color:
                                        horarioIniNoite !== ""
                                            ? "black"
                                            : "red",
                                    borderColor:
                                        horarioIniNoite !== ""
                                            ? "#787878"
                                            : "red",
                                }}
                                value={horarioIniNoite}
                                onChange={(e) =>
                                    setHorarioIniNoite(e.target.value)
                                }
                                required
                            />
                            <label
                                htmlFor="HorarioInicialN"
                                style={{
                                    color:
                                        horarioIniNoite !== ""
                                            ? "black"
                                            : "red",
                                }}
                            >
                                Horário inicial
                            </label>
                        </div>
                    </Col>
                    <Col>
                        <div className="form-floating">
                            <StyledHourInput
                                type="time"
                                className="form-control"
                                id="HorarioFinalN"
                                style={{
                                    color:
                                        horarioFimNoite !== ""
                                            ? "black"
                                            : "red",
                                    borderColor:
                                        horarioFimNoite !== ""
                                            ? "#787878"
                                            : "red",
                                }}
                                placeholder="00:00"
                                value={horarioFimNoite}
                                onChange={(e) =>
                                    setHorarioFimNoite(e.target.value)
                                }
                                required
                            />
                            <label
                                htmlFor="HorarioFinalN"
                                style={{
                                    color:
                                        horarioFimNoite !== ""
                                            ? "black"
                                            : "red",
                                }}
                            >
                                Horário final
                            </label>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default CheckinRange;
